(() => {
  'use strict';

  function parseTireSize(value) {
    if (!value) return null;
    const text = String(value).toUpperCase().replace(/ZR/g, 'R');

    const metric = text.match(/(?:^|\D)(\d{3})\s*\/\s*(\d{2,3})\s*R\s*-?\s*(\d{2}(?:\.5)?)(?:\D|$)/);
    if (metric) {
      return {
        format: 'metric',
        width: Number(metric[1]),
        aspect: Number(metric[2]),
        rim: Number(metric[3])
      };
    }

    const flotationX = text.match(/(?:^|\D)(\d{2}(?:\.\d+)?)\s*X\s*(\d{1,2}(?:\.\d+)?)\s*(?:R|-)?\s*(\d{2}(?:\.5)?)(?:\D|$)/);
    if (flotationX) {
      return {
        format: 'flotation',
        diameter: Number(flotationX[1]),
        width: Number(flotationX[2]),
        rim: Number(flotationX[3])
      };
    }

    const flotationSlash = text.match(/(?:^|\D)(\d{1,2}(?:\.\d+)?)\s*\/\s*(\d{1,2}(?:\.\d+)?)(?:[A-Z]{0,3})?\s*-\s*(\d{2}(?:\.5)?)(?:\D|$)/);
    if (flotationSlash) {
      const first = Number(flotationSlash[1]);
      const second = Number(flotationSlash[2]);
      const diameter = Math.max(first, second);
      const width = Math.min(first, second);
      if (diameter >= 16 && diameter <= 60 && width >= 1.5 && width <= 24) {
        return {
          format: 'flotation',
          diameter,
          width,
          rim: Number(flotationSlash[3])
        };
      }
    }

    return null;
  }

  function serializeSize(size) {
    if (!size) return '';
    if (size.format === 'metric') return `m:${size.width}:${size.aspect}:${size.rim}`;
    return `f:${size.diameter}:${size.width}:${size.rim}`;
  }

  function formatSize(size) {
    if (!size) return '';
    if (size.format === 'metric') return `${size.width}/${size.aspect}R${size.rim}`;
    return `${size.diameter}X${size.width}R${size.rim}`;
  }

  class SMGTireContextualCta extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      const mode = this.dataset.mode || 'product';
      const context = this.dataset.context || '';
      const parsed = parseTireSize(context);
      const relevantSearch = parsed || /\b(tire|tires|tyre|tyres|drag\s+radial|slick|front\s+runner)\b/i.test(context);

      if (mode === 'search' && !relevantSearch) {
        this.hidden = true;
        return;
      }

      const link = this.querySelector('[data-calculator-link]');
      if (link && parsed) {
        try {
          const url = new URL(link.href, window.location.origin);
          url.searchParams.set('smg_s2', serializeSize(parsed));
          url.searchParams.set('smg_mode', 'compare');
          link.href = url.toString();
        } catch (error) {
          // The calculator link remains usable even if URL enhancement fails.
        }
      }

      const detected = this.querySelector('[data-detected-size]');
      if (detected) {
        if (parsed) {
          detected.textContent = `${formatSize(parsed)} will be preloaded for comparison.`;
          detected.hidden = false;
        } else {
          detected.hidden = true;
        }
      }

      this.hidden = false;
    }
  }

  if (!customElements.get('smg-tire-contextual-cta')) {
    customElements.define('smg-tire-contextual-cta', SMGTireContextualCta);
  }
})();
